import PropTypes from 'prop-types';
import { memo } from 'react';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import Ticket from '../../models/Ticket';
import TicketItem from '../common/TicketItem';
import { jsx as _jsx } from "react/jsx-runtime";
function TicketCardItem(props) {
  return /*#__PURE__*/_jsx(UICardWrapper, {
    compact: true,
    children: /*#__PURE__*/_jsx(UICardSection, {
      className: "p-all-3",
      children: /*#__PURE__*/_jsx(TicketItem, {
        ticket: props.ticket
      })
    })
  });
}
TicketCardItem.propTypes = {
  ticket: PropTypes.instanceOf(Ticket).isRequired
};
export default /*#__PURE__*/memo(TicketCardItem);